// eslint-disable-next-line import/prefer-default-export
export const SCROLL_TO_TOP_BUTTON_SHOW_PX = 100;
